import { defineStore } from 'pinia';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { pagedListState, pagedListActions } from '@/services/createPagedListStore';
import MatterService from '@/services/MatterService';

export const useMattersStore = defineStore('mattersStore', {
  state: () => {
    const { handleError } = useSnackbarHandler();
    return {
      ...pagedListState(),
      handleError,
    };
  },
  getters: {
    matters: (state) => state.items,
  },
  actions: {
    ...pagedListActions('/matters/table'),
    listMatters(params: Record<string, unknown>) {
      return this.list(params);
    },

    async bulkChangeResponsible(ids: string[], accountId: string) {
      this.loading = true;
      try {
        return await MatterService.bulkChangeResponsible(ids, accountId);
      } catch (error) {
        this.handleError(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async bulkArchive(ids: string[], archive: boolean) {
      this.loading = true;
      try {
        return await MatterService.bulkArchive(ids, archive);
      } catch (error) {
        this.handleError(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async bulkApplyRateGroup(ids: string[], rateGroupId: string, updateEntries: boolean) {
      this.loading = true;
      try {
        return await MatterService.bulkApplyRateGroup(ids, rateGroupId, updateEntries);
      } catch (error) {
        this.handleError(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async bulkUpdateLedes(ids: string[], enabled: boolean, format: string | null) {
      this.loading = true;
      try {
        return await MatterService.bulkUpdateLedes(ids, enabled, format);
      } catch (error) {
        this.handleError(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
  },
});

export default useMattersStore;
